import { useLocation, useParams } from 'react-router';

export const useWishlistId = () => {
  const { search } = useLocation();
  const { sharedListId, listId } = useParams();

  const sharedListIdFromSearch = search
    ? new URLSearchParams(search).get('id')
    : null;

  return {
    listId,
    sharedListId: sharedListId || sharedListIdFromSearch,
  };
};
